import type { Appointment } from "../models";
import {
  appointmentSchema,
  MEDICATION_REQUEST_APPOINTMENT_TYPES,
} from "../models";

export const isAppointment = (data: unknown): data is Appointment => {
  return appointmentSchema.safeParse(data).success;
};

export const isMedicationRequestAppointment = (type: Appointment["type"]) => {
  return MEDICATION_REQUEST_APPOINTMENT_TYPES.some(
    (appointmentType) => appointmentType === type,
  );
};
